"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavBarContext = void 0;
var _react = _interopRequireWildcard(require("react"));
require("../../jscomponents/NavBarTop/NavBarTop.scss");
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
require("./NavBar.scss");
var _logoIcon = _interopRequireDefault(require("../../images/logo-icon.svg"));
var _user = _interopRequireDefault(require("../../images/user.svg"));
var _WaffleMenu = _interopRequireDefault(require("../../jscomponents/WaffleMenu/WaffleMenu"));
var _MegaMenu = _interopRequireDefault(require("../MegaMenu/MegaMenu"));
var _MegaNav = _interopRequireDefault(require("../MegaNav/MegaNav"));
var _NavBarTop2 = _interopRequireDefault(require("../NavBarTop/NavBarTop"));
var _MobileNav = _interopRequireDefault(require("../MobileNav/MobileNav"));
var _NavMiniMenu = _interopRequireDefault(require("./NavMiniMenu"));
var _SubNav = _interopRequireDefault(require("../SubNav/SubNav"));
var _OnPageNav = _interopRequireDefault(require("../OnPageNav/OnPageNav"));
var _Flyout = _interopRequireDefault(require("../Flyout/Flyout"));
var _NavOption = _interopRequireDefault(require("./NavOption"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _InPageJumpNav = _interopRequireDefault(require("../InPageJumpNav/InPageJumpNav"));
var _CartNavMenu = _interopRequireDefault(require("./CartNavMenu/CartNavMenu"));
var _FlyoutCart = _interopRequireDefault(require("../FlyoutCart/FlyoutCart"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const NavBarContext = /*#__PURE__*/(0, _react.createContext)({
  currentOpenMenu: null,
  hamburgerIsOpen: false,
  searchField: "",
  searchFieldValue: "",
  regionLanguageID: "language-selector",
  noImmediateMouseOver: false,
  mouse: true,
  isBottomBarActive: false,
  handleSearchFieldChange: e => {},
  handleSearchSubmit: () => {},
  deployDropDown: () => {},
  openDropDown: () => {},
  closeDropDown: () => {},
  preventImmediateMouseOver: () => {},
  hamburgerClick: () => {},
  handleMouseDown: () => {},
  handleKeyDown: () => {},
  setMouse: () => {},
  closeAllDropDowns: () => {},
  checkScroll: () => {},
  closeHamburger: () => {},
  sectorFlyoutData: null,
  sectorFlyoutDeployed: false,
  handleSectorFlyoutDeployed: () => {},
  languageSelectorDeployed: false,
  handleLanguageSelectorDeployed: () => {},
  desktopSearchDeployed: false,
  setDesktopSearchDeployed: () => {},
  isWaffleMenuDeployed: false,
  setWaffleMenuDeployed: () => {}
});
exports.NavBarContext = NavBarContext;
const NavBar = props => {
  const {
    divisionName,
    logo,
    rightLinks,
    Link,
    featuredLink,
    searchPlaceholder,
    disableLogin,
    disableSearch,
    disableLanguageRegion,
    disableSectorFlyOut = true,
    disableMenus,
    login,
    navOptions,
    isExpanded,
    searchSubmit,
    handleSectorFlyoutDeployed = () => {},
    sectorFlyoutDeployed,
    sectorFlyoutData,
    searchFlyoutSubmit,
    subNavData,
    languageSelectorData,
    languageSelectorDeployed,
    handleLanguageSelectorDeployed = () => {},
    saveLanguage = language => {},
    searchComponent,
    searchDeployed,
    setSearchDeployed,
    isAuthenticated,
    userProfile,
    loginPage,
    logout,
    displayIcons,
    displaySectorName,
    topNavTheme,
    menuBarTheme,
    navigate,
    authLabels,
    setGlobalSearch,
    globalSearch,
    waffleMenu,
    showJumpNav,
    jumpNavItems,
    navRef,
    currencies = [],
    defaultCurrency = "USD",
    activeCurrency = "USD",
    setCurrency,
    isCurrencyLocked = false,
    cartData,
    disableCartFlyout = true,
    cartSettings,
    isCartFlyoutOpen = false,
    onCartFlyoutOpen = () => {},
    onCartRemoveItem,
    onCartChangeQuantity,
    onPageNavData,
    megaNavVariant,
    alertHolderComponent
  } = props;
  const [currentOpenMenu, setCurrentOpenMenu] = (0, _react.useState)(null);
  const [hamburgerIsOpen, setHamburgerIsOpen] = (0, _react.useState)(false);
  const [searchField, setSearchField] = (0, _react.useState)("");
  const [searchFieldValue, setSearchFieldValue] = (0, _react.useState)("");
  const [noImmediateMouseOver, setNoImmediateMouseOver] = (0, _react.useState)(false);
  const [isHidden, setIsHidden] = (0, _react.useState)(false);
  const [lastPosition, _setLastPosition] = (0, _react.useState)(100);
  const [desktopSearchDeployed, setDesktopSearchDeployed] = (0, _react.useState)(searchDeployed);
  const [pathname, setPathname] = (0, _react.useState)(false);
  const [isBottomBarActive, setIsBottomBarActive] = (0, _react.useState)(true);
  const [isCartFlyoutActive, setCartFlyoutActive] = (0, _react.useState)(isCartFlyoutOpen);
  const [megaNavIsActive, setMegaNavIsActive] = (0, _react.useState)(false); // determines whether to display megaNav background overlay (should only display when megaNav is open)

  const navBarWrapperRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    setDesktopSearchDeployed(searchDeployed);
  }, [searchDeployed]);
  (0, _react.useEffect)(() => {
    setCartFlyoutActive(isCartFlyoutOpen);
  }, [isCartFlyoutOpen]);
  (0, _react.useEffect)(() => {
    if (typeof onCartFlyoutOpen === "function") {
      onCartFlyoutOpen(isCartFlyoutActive);
    }
  }, [isCartFlyoutActive]);
  const {
    mouse
  } = (0, _useMouse.default)();
  const lastPositionRef = (0, _react.useRef)(lastPosition);
  (0, _react.useEffect)(() => {
    if (window) {
      setPathname(window.location.pathname);
    }
  }, []);
  (0, _react.useEffect)(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("click", closeAllDropDowns);
      window.addEventListener("scroll", checkScroll);
    }
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("click", closeAllDropDowns);
        window.removeEventListener("scroll", checkScroll);
      }
    };
  }, []);
  (0, _react.useEffect)(() => {
    if (currentOpenMenu) {
      handleSectorFlyoutDeployed(false);
      handleLanguageSelectorDeployed(false);
    }
  }, [currentOpenMenu]);
  (0, _react.useEffect)(() => {
    setSearchDeployed(desktopSearchDeployed);
  }, [desktopSearchDeployed]);
  const setLastPosition = data => {
    lastPositionRef.current = data;
    _setLastPosition(data);
  };
  const subNavDisplay = subNavData?.breadcrumbs?.length || subNavData?.siblingPages?.length;
  const closeHamburger = () => {
    setHamburgerIsOpen(false);
    setCurrentOpenMenu(null);
    setSearchField("");
  };
  const handleSearchFieldChange = e => {
    setSearchField(e.target.value);
  };
  const handleSearchSubmit = () => {
    if (!searchFieldValue) {
      searchSubmit(searchField);
      closeHamburger();
    }
  };
  const checkScroll = () => {
    if (!hamburgerIsOpen) {
      const position = window?.scrollY;
      if (typeof position !== undefined && position > lastPositionRef.current + 100) {
        setIsHidden(true);
        setLastPosition(position);
        setCurrentOpenMenu(null);
        closeHamburger();
      } else if (typeof position !== undefined && position < lastPositionRef.current) {
        setIsHidden(false);
        setLastPosition(position);
      }
      handleBottomBar(position);
    }
  };
  const handleBottomBar = position => {
    if (typeof position !== undefined && position > 20) {
      setIsBottomBarActive(false);
    } else {
      setIsBottomBarActive(true);
    }
  };
  const closeAllDropDowns = () => {
    setCurrentOpenMenu(null);
  };
  const preventImmediateMouseOver = () => {
    setNoImmediateMouseOver(true);
    setTimeout(() => {
      setNoImmediateMouseOver(false);
    }, 500);
  };
  const deployDropDown = (e, menu) => {
    if (currentOpenMenu !== menu) {
      setCurrentOpenMenu(menu);
      setMegaNavIsActive(false);
    } else {
      setCurrentOpenMenu(null);
    }
  };
  const openDropDown = menu => {
    //prevent unnecessary re-renders
    if (menu !== currentOpenMenu) {
      setCurrentOpenMenu(menu);
    }
  };
  const closeDropDown = menu => {
    if (currentOpenMenu === menu || !menu) {
      setCurrentOpenMenu(null);
      setMegaNavIsActive(false);
    }
  };
  const stopProp = e => {
    e.stopPropagation();
  };
  const getUrl = option => {
    if (option?.url) {
      return option?.url;
    }
    if (option?.links?.[0]?.url) {
      return option?.links?.[0]?.url;
    }
    if (option?.links?.[0]?.links?.[0]?.url) {
      return option?.links?.[0]?.links?.[0]?.url;
    }
    if (option?.links?.[0]?.links?.[0]?.links?.[0]?.url) {
      return option?.links?.[0]?.links?.[0]?.links?.[0]?.url;
    }
    return null;
  };
  const generateNavOptions = () => {
    let hasActiveNavOption = false;
    return navOptions?.map((option, i) => {
      if (!option) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
      }
      const isCollapsed = !isExpanded;
      const url = getUrl(option) ? getUrl(option)?.split("/")[2] : null;
      const path = pathname && pathname.split("/")[2];

      // to determine if active, check if nav url is in the first breadcrumb after the local of the pathname
      const active = path && path?.includes(url) && !hasActiveNavOption;
      if (active) {
        hasActiveNavOption = true;
      }
      if (option?.type === "megaNav") {
        return /*#__PURE__*/_react.default.createElement(_MegaNav.default, {
          key: `${option?.text}-${i}`,
          isOpen: currentOpenMenu === option?.contentfulId,
          content: option,
          currentOpenMenu: currentOpenMenu,
          parentWrapperRef: navBarWrapperRef,
          Link: Link,
          setMegaNavIsActive: setMegaNavIsActive
        });
      } else {
        if (option?.text) {
          return /*#__PURE__*/_react.default.createElement(_NavOption.default, {
            key: `${option?.text}-${i}`,
            displayIcons: displayIcons,
            option: option,
            menuBarTheme: menuBarTheme,
            navigate: navigate
          }, option.type === "category" ? /*#__PURE__*/_react.default.createElement(_MegaMenu.default, {
            isOpen: currentOpenMenu === option?.contentfulId,
            content: option,
            Link: Link,
            collapsed: isCollapsed,
            currentOpenMenu: currentOpenMenu,
            displayIcons: displayIcons,
            icon: option.icon,
            theme: menuBarTheme,
            active: active
          }) : option.type === "links" ? /*#__PURE__*/_react.default.createElement(_NavMiniMenu.default, {
            navText: option?.text,
            contentfulId: option?.contentfulId,
            links: option?.links,
            isOpen: currentOpenMenu === option?.contentfulId,
            Link: Link,
            displayIcons: displayIcons,
            icon: option.icon,
            theme: menuBarTheme,
            currentOpenMenu: currentOpenMenu,
            active: active,
            navBarWrapperRef: navBarWrapperRef,
            megaNavVariant: megaNavVariant
          }) : /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
            to: option?.url,
            depth: 1,
            tabIndex: mouse ? "" : "0",
            href: option?.url,
            className: `${mouse ? "ter-navbar__nav-link" : "ter-navbar__nav-link tabFocus"} 
                  ${active ? `active` : ""}
                  ${menuBarTheme ? `ter-navbar__nav-link--${menuBarTheme}` : ""}
                  ${displayIcons ? "ter-navbar__nav-link--with-icon" : ""}
                  ${displayIcons && menuBarTheme ? `ter-navbar__nav-link--with-icon--${menuBarTheme}` : ""}`,
            Link: Link,
            onClick: closeAllDropDowns,
            displayIcons: displayIcons,
            icon: option?.icon,
            navigate: navigate,
            internalLink: option?.internalLink,
            ariaLabel: option?.external === true ? `Open ${option.text} in a new tab` : null,
            target: typeof option?.external === "boolean" ? option?.external ? "_blank" : "_self" : null
          }, /*#__PURE__*/_react.default.createElement("p", null, option.text)));
        } else {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
        }
      }
    });
  };
  const generateFeaturedLink = () => /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-navbar-featured-link"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-navbar-featured-link__pipe-wrapper"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-navbar-top__pipe"
  }, "|")), /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    to: featuredLink?.url,
    tabIndex: mouse ? "" : "0",
    href: featuredLink?.url,
    key: featuredLink?.text,
    className: mouse ? "ter-navbar__nav-link" : "ter-navbar__nav-link tabFocus",
    target: featuredLink?.external ? "_blank" : "_self",
    Link: Link
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "featured-link"
  }, featuredLink?.text)));
  const hamburgerClick = () => {
    setHamburgerIsOpen(!hamburgerIsOpen);
    setSearchField("");
    if (hamburgerIsOpen && sectorFlyoutDeployed) {
      handleSectorFlyoutDeployed();
    }
  };
  const regionLanguageID = "language-selector";
  const [isWaffleMenuDeployed, setWaffleMenuDeployed] = (0, _react.useState)(false);
  const [isCurrencyMenuDeployed, setCurrencyMenuDeployed] = (0, _react.useState)(false);
  return /*#__PURE__*/_react.default.createElement(NavBarContext.Provider, {
    value: {
      mouse,
      currentOpenMenu,
      hamburgerIsOpen,
      searchField,
      searchFieldValue,
      noImmediateMouseOver,
      regionLanguageID,
      isBottomBarActive,
      hamburgerClick,
      handleSearchFieldChange,
      handleSearchSubmit,
      deployDropDown,
      openDropDown,
      closeDropDown,
      closeAllDropDowns,
      checkScroll,
      preventImmediateMouseOver,
      closeHamburger,
      sectorFlyoutDeployed,
      handleSectorFlyoutDeployed,
      languageSelectorDeployed,
      handleLanguageSelectorDeployed,
      desktopSearchDeployed,
      setDesktopSearchDeployed,
      isWaffleMenuDeployed,
      setWaffleMenuDeployed,
      isCurrencyMenuDeployed,
      setCurrencyMenuDeployed,
      sectorFlyoutData,
      cartSettings,
      cartData
    }
  }, /*#__PURE__*/_react.default.createElement("nav", {
    className: `ter-navbar ter-navbar${isHidden && window?.scrollY > 100 && !desktopSearchDeployed ? "--is-hidden" : "--is-showing"}`,
    onClick: stopProp,
    ref: navRef
  }, /*#__PURE__*/_react.default.createElement(_NavBarTop2.default, {
    divisionName: divisionName,
    logo: logo,
    rightLinks: rightLinks || [],
    hamburgerIsOpen: hamburgerIsOpen,
    searchField: searchField,
    handleSearchFieldChange: handleSearchFieldChange,
    placeholder: searchPlaceholder,
    handleSearchSubmit: handleSearchSubmit,
    regionLanguageID: regionLanguageID,
    Link: Link,
    disableLogin: disableLogin,
    disableSearch: disableSearch,
    disableLanguageRegion: disableLanguageRegion,
    disableSectorFlyOut: disableSectorFlyOut,
    languageSelectorData: languageSelectorData,
    languageSelectorDeployed: languageSelectorDeployed,
    handleLanguageSelectorDeployed: handleLanguageSelectorDeployed,
    saveLanguage: saveLanguage,
    searchComponent: searchComponent,
    searchDeployed: searchDeployed,
    setSearchDeployed: setSearchDeployed,
    displaySectorName: displaySectorName,
    theme: topNavTheme,
    desktopSearchDeployed: desktopSearchDeployed,
    setDesktopSearchDeployed: setDesktopSearchDeployed,
    globalSearch: globalSearch,
    setGlobalSearch: setGlobalSearch,
    waffleMenu: true,
    sectorFlyoutData: sectorFlyoutData,
    cartSettings: cartSettings
  }, (disableCartFlyout === false || sectorFlyoutData?.authenticated || sectorFlyoutData?.login && !disableLogin) && /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-navbar-top__pipe"
  }, "|"), disableCartFlyout === false && /*#__PURE__*/_react.default.createElement(_CartNavMenu.default, {
    count: cartData?.totalLineItemQuantity,
    isCartFlyoutActive: isCartFlyoutActive,
    setCartFlyoutActive: setCartFlyoutActive,
    isCurrencyLocked: isCurrencyLocked,
    defaultCurrency: defaultCurrency,
    activeCurrency: activeCurrency,
    setCurrency: setCurrency,
    currencies: currencies,
    isCurrencyMenuDeployed: isCurrencyMenuDeployed,
    setCurrencyMenuDeployed: setCurrencyMenuDeployed,
    settings: cartSettings
  }), sectorFlyoutData?.authenticated && /*#__PURE__*/_react.default.createElement(_WaffleMenu.default, {
    links: waffleMenu?.links,
    cta: waffleMenu?.cta,
    Link: Link
  }), sectorFlyoutData?.login && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "ter-utility-nav__my-account",
    onClick: () => {
      handleSectorFlyoutDeployed();
      setDesktopSearchDeployed(false);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _user.default,
    className: "ter-utility-nav__my-account__icon",
    width: "21",
    height: "21",
    alt: ""
  }))), !disableSectorFlyOut && /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-navbar__flyout-wrapper ${sectorFlyoutDeployed ? "ter-navbar__flyout-wrapper--hidden" : ""}`,
    "aria-haspopup": "true",
    "aria-expanded": sectorFlyoutDeployed,
    "aria-label": "toggle flyout menu"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "ter-navbar__flyout-btn",
    type: "button",
    tabIndex: mouse ? "" : "0",
    onClick: () => {
      closeAllDropDowns();
      handleLanguageSelectorDeployed(false);
      setDesktopSearchDeployed(false);
      handleSectorFlyoutDeployed();
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-navbar__flyout-caret"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: "ter-navbar__flyout-caret-icon",
    size: "12px",
    type: "ter-icon--open-caret-left-dark-16px",
    color: "#0063A3"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-navbar__flyout-logo"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _logoIcon.default,
    alt: "open flyout"
  })))), sectorFlyoutData && /*#__PURE__*/_react.default.createElement(_Flyout.default, _extends({
    Link: Link,
    close: handleSectorFlyoutDeployed,
    searchSubmit: searchFlyoutSubmit,
    searchDeployed: searchDeployed,
    setSearchDeployed: setSearchDeployed,
    sectorFlyoutDeployed: sectorFlyoutDeployed,
    desktopSearchDeployed: desktopSearchDeployed,
    setDesktopSearchDeployed: setDesktopSearchDeployed,
    closeHamburger: closeHamburger,
    globalSearch: globalSearch,
    setGlobalSearch: setGlobalSearch
  }, sectorFlyoutData)), /*#__PURE__*/_react.default.createElement("div", {
    className: `luna-layout__navigation-padding ${menuBarTheme ? `luna-layout__navigation-padding--${menuBarTheme}` : ""}`
  }, !disableMenus && /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-navbar__wrapper 
              ${menuBarTheme ? `ter-navbar__wrapper--${menuBarTheme}` : ""}
              ${displayIcons ? "ter-navbar__wrapper--with-icons" : ""}
              ${displayIcons && menuBarTheme ? `ter-navbar__wrapper--with-icons--${menuBarTheme}` : ""}
              ${megaNavVariant === true ? `ter-navbar__wrapper--mega-nav` : ""}
              `,
    ref: navBarWrapperRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-navbar__menus-wrapper ${displayIcons ? `ter-navbar__menus-wrapper--with-icons` : ""}`
  }, generateNavOptions(), featuredLink && generateFeaturedLink())), megaNavVariant === true && /*#__PURE__*/_react.default.createElement("hr", {
    className: "ter-mega-nav__underline"
  })), /*#__PURE__*/_react.default.createElement(_MobileNav.default, {
    rightLinks: rightLinks,
    navOptions: navOptions,
    disableLogin: disableLogin,
    disableLanguageRegion: disableLanguageRegion,
    disableSectorFlyOut: disableSectorFlyOut,
    handleSectorFlyoutDeployed: handleSectorFlyoutDeployed,
    sectorFlyoutLabel: sectorFlyoutData?.mobileLabel,
    languageSelectorData: languageSelectorData,
    languageSelectorDeployed: languageSelectorDeployed,
    handleLanguageSelectorDeployed: handleLanguageSelectorDeployed,
    loginPage: loginPage,
    login: login,
    isHidden: disableLogin,
    Link: Link,
    isAuthenticated: isAuthenticated,
    userProfile: userProfile,
    logout: logout,
    authLabels: authLabels,
    waffleMenu: waffleMenu,
    featuredLink: featuredLink,
    closeAllDropDowns: closeAllDropDowns,
    saveLanguage: saveLanguage,
    disableCartFlyout: disableCartFlyout,
    cartSettings: cartSettings,
    cartData: cartData,
    isCartFlyoutActive: isCartFlyoutActive,
    setCartFlyoutActive: setCartFlyoutActive,
    defaultCurrency: defaultCurrency,
    activeCurrency: activeCurrency,
    setCurrency: setCurrency,
    currencies: currencies,
    isCurrencyLocked: isCurrencyLocked
  }), subNavDisplay ? /*#__PURE__*/_react.default.createElement(_SubNav.default, {
    Link: Link,
    breadcrumbs: subNavData?.breadcrumbs,
    siblings: subNavData?.siblingPages,
    isHidden: isHidden
  }) : null, onPageNavData?.navItems?.length > 0 && /*#__PURE__*/_react.default.createElement(_OnPageNav.default, {
    navCta: onPageNavData?.navCta,
    navTitle: onPageNavData?.navTitle,
    navItems: onPageNavData?.navItems
  }), alertHolderComponent && alertHolderComponent, showJumpNav === true && /*#__PURE__*/_react.default.createElement(_InPageJumpNav.default, {
    pageSections: jumpNavItems,
    navType: "horizontal"
  })), megaNavVariant === true && megaNavIsActive === true && /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-navbar__overlay ${currentOpenMenu != null ? "ter-navbar__overlay--visible" : ""}`
  }), disableCartFlyout === false && /*#__PURE__*/_react.default.createElement(_FlyoutCart.default, {
    cartData: cartData,
    cartSettings: cartSettings,
    isAuthenticated: sectorFlyoutData?.authenticated,
    isCartFlyoutActive: isCartFlyoutActive,
    setCartFlyoutActive: setCartFlyoutActive,
    onRemove: onCartRemoveItem,
    onChangeQuantity: onCartChangeQuantity,
    Link: Link
  }));
};
var _default = NavBar;
exports.default = _default;